<template>
  <div class="modal-footer">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "modal-footer"
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Modal/ModalFooter.vue